import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

const invoiceTypeKeys = {
  0: '33333333-3333-3333-3333-333333333333',
  1: '44444444-4444-4444-4444-444444444444',
  2: '55555555-5555-5555-5555-555555555555',
};

angular.module('cloudX').directive('cxInvoiceScheduleTypeCheckboxSelect', [
  'enumCacheSvc',
  '$filter',
  '$rootScope',
  '$q',
  '$http',
  'appUrls',
  function(enumCacheSvc, $filter, $rootScope, $q, $http, appUrls) {
    return {
      restrict: 'E',
      require: '^ngModel',
      template: `<div class="dropdown" uib-dropdown is-open="ddwOpen" auto-close="outsideClick" on-toggle="toggleDropDown(open)">
                  <div class="input-group">
                    <input type="text" class="form-control form-control-readonly" readonly ng-value="displayValue" ng-focus="ddwOpen=true" ng-click="ddwOpen=true; $event.stopPropagation(); $event.preventDefault();" autocomplete="off" placeholder="{{placeholder || ('InvoiceSchedules'|translate)}}" />
                    <div class="input-group-btn">
                      <button class="btn btn-default dropdown-toggle" ng-if="displayValue==''" uib-dropdown-toggle>
                        <span class="caret"></span>
                      </button>
                      <button class="btn btn-default" ng-if="displayValue!=''" ng-click="clearSelected()">
                        <span class="fa fa-times"></span>
                      </button>
                    </div>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu" style="max-height:30vh;overflow-y:auto">
                    <li ng-repeat="item in items | orderBy:['sortKey','label'] track by item.key" ng-class="{'divider':item.type===-1}">
                      <a href ng-click="toggleItem(item)" ng-hide="item.type===-1">
                        <i class="fa margin5R" ng-class="item.selected?'fa-check-square-o':'fa-square-o'"></i><span ng-bind="item.label"></span>
                      </a>
                    </li>
                  </ul>
                </div>`,
      scope: {
        hideInvoicingVia: '@?',
        placeholder: '@?',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.items = [];
        scope.initOnload = null;
        scope.displayValue = '';
        scope.ddwOpen = false;

        var deferred = $q.defer();
        $q.all([
          enumCacheSvc.get('invoicingType'),
          $http.get(`${appUrls.api}/api/invoiceschedule/get`, {
            timeout: deferred.promise,
            cancel: deferred,
          }),
        ]).then(([invoiceTypes, { data: invoiceSchedules }]) => {
          const fixedItems = [
            {
              key: '00000000-0000-0000-0000-000000000000',
              name: 'NoInvoicingSchedule',
              type: 1,
              sortKey: 1,
            },
            {
              key: '11111111-1111-1111-1111-111111111111',
              name: 'WithInvoicingSchedule',
              type: 1,
              sortKey: 2,
            },
          ];
          if (!scope.hideInvoicingVia) {
            fixedItems.push({
              key: '22222222-2222-2222-2222-222222222222',
              name: 'InvoicingViaRelations',
              type: 1,
              sortKey: 3,
            });
          }

          scope.items = [
            ...fixedItems,
            {
              key: 'separator1',
              type: -1,
              sortKey: 5,
            },
            ...invoiceTypes.map(x => ({
              ...x,
              id: x.key,
              key: invoiceTypeKeys[x.key],
              type: 2,
              sortKey: 6,
            })),
            {
              key: 'separator2',
              type: -1,
              sortKey: 7,
            },
            ...invoiceSchedules.map(x => ({
              key: x.id,
              name: x.name,
              type: 3,
              sortKey: 8,
            })),
          ].map(x => ({
            ...x,
            selected: scope.initOnload && scope.initOnload.indexOf(x.key) >= 0,
          }));
          translateLabels();
        });

        function translateItem(item) {
          if (item.type === 1) {
            switch (item.key[0]) {
              case '0':
                return $filter('translate')('NoInvoicingSchedule');
              case '1':
                return $filter('translate')('WithInvoicingSchedule');
              case '2':
                return $filter('translate')('InvoicingViaRelations');
              default:
                return '';
            }
          }
          if (item.type === 2) {
            return $filter('translateList')(item.id, 'invoicingtype', item.value);
          }
          if (item.type === 3) {
            return $filter('translateList')(item.key, 'invoiceschedule', item.name);
          }
          return '';
        }

        function translateLabels() {
          scope.items.forEach(function(item) {
            item.label = translateItem(item);
          });
          scope.setDisplayValue();
        }
        var deregistration = $rootScope.$on('$translateChangeSuccess', translateLabels);
        scope.$on('$destroy', deregistration);

        scope.toggleItem = function(item) {
          item.selected = !item.selected;
          scope.setDisplayValue();
        };

        scope.setDisplayValue = function() {
          scope.displayValue = scope.items
            .filter(x => x.selected)
            .sort(dynamicSortMultiple('sortKey', 'label'))
            .map(x => x.label)
            .join(', ');
        };
        scope.clearSelected = function() {
          if (scope.items) {
            scope.items.forEach(x => {
              x.selected = false;
            });
          }
          scope.displayValue = '';
          ngModel.$setViewValue([]);
          scope.ddwOpen = false;
        };

        scope.toggleDropDown = function(open) {
          if (!open) {
            const value = scope.items
              .filter(x => x.selected)
              .map(x => x.key)
              .sort();
            ngModel.$setViewValue(value);
          }
        };

        ngModel.$render = function() {
          const value = ngModel.$viewValue || [];
          if (scope.items && scope.items.length) {
            if (value.length) {
              scope.items.forEach(x => {
                x.selected = value && value.indexOf(x.key) >= 0;
              });
              scope.setDisplayValue();
            } else {
              scope.clearSelected();
            }
          } else {
            scope.initOnload = value;
          }
        };
      },
    };
  },
]);
